/** Shared org_profile attribute rows (Entra / Graph). */

const ORG_FIELDS = [
  { key: 'job_title', label: 'Cargo' },
  { key: 'department', label: 'Departamento / Gerencia' },
  { key: 'company_name', label: 'Empresa' },
  { key: 'office_location', label: 'Oficina' },
  { key: 'manager_display_name', label: 'Jefe' },
  { key: 'manager_email', label: 'Email jefe' },
  { key: 'manager_sync_error', label: 'Error al leer el jefe' },
  { key: 'synced_at', label: 'Sincronizado' },
  { key: 'sync_error', label: 'Error sync' },
  { key: 'graph_user_id', label: 'Graph user id' },
];

const CAMPOS_DE_ERROR = new Set(['sync_error', 'manager_sync_error']);
const CAMPOS_MONO = new Set(['graph_user_id', 'synced_at', 'sync_error', 'manager_sync_error']);

export function orgProfileSummary(org) {
  if (!org) return '';
  return [
    org.job_title,
    org.department,
    org.manager_display_name && `Jefe: ${org.manager_display_name}`,
  ].filter(Boolean).join(' · ');
}

export default function OrgProfileAttributes({
  orgProfile,
  title = 'Organigrama (Microsoft)',
  onRefresh,
  refreshing = false,
  className = '',
}) {
  const org = orgProfile || null;
  const hasAny = org && ORG_FIELDS.some((f) => org[f.key] != null && org[f.key] !== '');
  // "No tiene jefe" y "Graph no me dejo leerlo" se veian igual: los dos como una fila
  // ausente. De `manager_email` cuelga que un gerente vea los casos de su gente, asi que una
  // bandeja vacia por un 403 se leia como "no tiene gente a cargo".
  const jefeIlegible = Boolean(org?.manager_sync_error) && !org?.manager_display_name;

  return (
    <div className={`border border-zinc-200 rounded-sm bg-zinc-50/80 p-3 space-y-2 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[10px] uppercase tracking-wider text-zinc-500 font-semibold">{title}</p>
        {onRefresh ? (
          <button
            type="button"
            onClick={onRefresh}
            disabled={refreshing}
            className="text-[10px] text-brand-primary hover:underline disabled:opacity-50"
          >
            {refreshing ? 'Actualizando…' : 'Actualizar organigrama'}
          </button>
        ) : null}
      </div>
      {!hasAny ? (
        <p className="text-[11px] text-zinc-400">Sin organigrama sincronizado.</p>
      ) : (
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5">
          {ORG_FIELDS.map(({ key, label }) => {
            const val = org[key];
            const esJefeIlegible = jefeIlegible && (key === 'manager_display_name' || key === 'manager_email');
            if ((val == null || val === '') && !esJefeIlegible) return null;
            const mono = CAMPOS_MONO.has(key);
            const err = CAMPOS_DE_ERROR.has(key) || esJefeIlegible;
            return (
              <div key={key} className="min-w-0">
                <dt className="text-[9px] uppercase tracking-wider text-zinc-400">{label}</dt>
                <dd
                  className={`text-[11px] break-all ${mono ? 'font-mono' : ''} ${err ? 'text-amber-800' : 'text-zinc-800'}`}
                >
                  {esJefeIlegible ? 'No se pudo leer' : String(val)}
                </dd>
              </div>
            );
          })}
        </dl>
      )}
    </div>
  );
}
